import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';

import { Member } from '@asambleas-models/member.model';
import { LoadService } from '@asambleas-components/loader/loader.service';
import { MemberService } from '@asambleas-services/member/member.service';
import { PlanterService } from '@asambleas-services/planter/planter.service';
import { GeneralService } from '@asambleas-services/general/general.service';
import { PlanterFormModalComponent } from '@asambleas-components/modals/planter-form-modal/planter-form-modal.component';
import { AlertComponent } from '@asambleas-components/alert/alert.component';
import { NotificationsService } from '@asambleas-services/notifications/notifications.service';

@Component({
    selector: 'app-member-detail',
    templateUrl: './member-detail.component.html',
    styleUrls: ['./member-detail.component.css']
})
export class MemberDetailComponent implements OnInit {
    member: Member;
    loader: any;
    isModalOpen: boolean = false;

    constructor(
        private _activatedRoute: ActivatedRoute,
        private loadService: LoadService,
        public dialog: MatDialog,
        private memberService: MemberService,
        private planterService: PlanterService,
        private router: Router,
        private generalService: GeneralService,
        private _notification: NotificationsService
    ) { }

    ngOnInit() {
        this._activatedRoute.params.subscribe((parameters: Member) => {
            let memberId = parameters.id;
            this.member = this.generalService.members[memberId];
            if (this.member == null) {
                this.memberService.getMembers().subscribe(
                    (data: Member[]) => {
                        data.forEach(member => {
                            this.generalService.members[member.id] = member;
                            if (memberId == member.id) {
                                this.member = this.generalService.members[member.id];
                            }
                        });
                        console.log('member data ', this.member);
                    },
                    (error) => {
                        console.log('error', error)
                        this.router.navigate(['/admin', 'members']);
                    })
            }

        })
    }

    loadModalPostulatePlanter() {
        const dialogRef = this.dialog.open(PlanterFormModalComponent, {
            height: 'auto',
            minHeight: '63vh',
            disableClose: true,
            data: {
                title: "Postular plantador",
                subtitle: "Agregar una descripción de por que se desea postular al miembro.",
                member: this.member
            }
        });

        dialogRef.afterClosed().subscribe(response => {
            this.isModalOpen = false
            if (response != undefined) {
                this.loader = this.loadService.createLoad('');
                this.loader.open()
                console.log('response', response)
                console.log('member', this.member)

                this.planterService.postulateMemberToPlanter(this.member.id).subscribe((data) => {
                    this.loader.close()
                    this.router.navigate(['/admin', 'members']);
                }, (error) => {
                    console.log('error', error);
                    this.loader.close();
                    this.loadErrorModalPostulationPlanter(error.error.message);
                })
            }
        });
    }

    loadErrorModalPostulationPlanter(errorMessage: string) {
        let data = {
            title: 'Atención',
            content: errorMessage
        }

        this.dialog.open(AlertComponent, {
            width: '35vw',
            disableClose: true,
            data: data
        });
    }

    getConcept(value: string, conceptId: number) {
        let returnValue = '';
        const documentTypes = this.generalService.concepts[conceptId];
        Object.keys(documentTypes).forEach((key) => {
            if (value == documentTypes[key]['value']) {
                returnValue = documentTypes[key]['description']
            }
        });
        return returnValue
    }

    requestDelete(member: any) {
        this._notification.requestUserDelete(member)
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/members/member-detail/member-detail.component.ts